import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { MajakIcon } from '../../../common/components';
import { PaymentsList } from '../../../common/components/data-display';

const PaymentsPanel = ({ t, togglePayments, payments, role }) => (
  <div className="documents-panel-wrapper">
      <div className="panel-header">
        <h2>{t('Platby')}</h2>
        <MajakIcon onClick={togglePayments} type="zavriet" />
      </div>
      <PaymentsList payments={payments} role={role} />
  </div>
);

PaymentsPanel.propTypes = {
  t: PropTypes.func.isRequired,
  payments: PropTypes.array.isRequired,
  togglePayments: PropTypes.func.isRequired,
};

export default translate()(PaymentsPanel);



// WEBPACK FOOTER //
// ./src/features/dashboard/components/PaymentsPanel.js